import React, { useEffect } from "react";
import { Modal, Button } from "antd";
import "./ConfirmationModal.css";

export default function ConfirmationModal({
  title,
  bodyText,
  bodyComponent,
  open,
  okText,
  cancelText,
  onOk,
  onCancel,
  loading,
  maskClosable = false,
  closable = false,
  width,
  showOkButton = true,
  showCancelButton = true,
  className = "",
}) {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (e) => {
      if (loading) return;

      if (e.key === "Enter") {
        e.preventDefault();
        if (typeof onOk === "function") onOk();
      }

      if (e.key === "Escape") {
        if (!showCancelButton) return;
        e.preventDefault();
        if (typeof onCancel === "function") onCancel();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [loading, onCancel, onOk, open, showCancelButton]);

  const modalClassName = `ConfirmationModal ${className}`.trim();

  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      closable={closable}
      maskClosable={!loading && maskClosable}
      centered
      className={modalClassName}
      width={width}
      footer={[
        showCancelButton ? (
          <Button key="back" onClick={onCancel} disabled={loading}>
            {cancelText}
          </Button>
        ) : null,
        showOkButton ? (
          <Button key="submit" type="primary" loading={loading} disabled={loading} onClick={onOk}>
            {okText}
          </Button>
        ) : null,
      ]}
    >
      {bodyComponent ? (
        <div>
          {bodyComponent()}
        </div>
      // eslint-disable-next-line react/no-danger
      ) : (<p dangerouslySetInnerHTML={{ __html: bodyText }} />)}
    </Modal>
  );
}
